import React from "react";

interface SkeletonProps {
	bg?: string;
}

const Skeleton: React.FC<SkeletonProps & React.HTMLProps<HTMLDivElement>> = ({
	bg,
	...rest
}) => {
	let className = rest?.className || "";
	if (!className?.includes("rounded-")) {
		className += " rounded-md";
	}
	if (bg) {
		className += ` bg-${bg}`;
	}

	if (!className?.includes("bg-")) {
		className += " bg-gray dark:bg-dark";
	}

	return (
		<div {...rest} className={`animate-pulse ${className}`}>
			{rest.children}
		</div>
	);
};

export default Skeleton;
